import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import * as React from "react";
import { forwardRef, useRef, useCallback, createElement } from "react";
import { IconButton } from "@creditornot/cb-button";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { createCssVars, assignInlineCssVars, clsx } from "@creditornot/cb-utils";
import { color } from "@creditornot/cb-ingredients/design-tokens";
import "./style.css";
const SvgAlertDiamond = (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "m23 10.588-9.586-9.586a2 2 0 0 0-2.828 0L1 10.589a2 2 0 0 0 0 2.828l9.586 9.585a2 2 0 0 0 2.828 0L23 13.417a2 2 0 0 0 0-2.83Zm-11.932-4.17a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6Zm1.051 11.51h-.028a1.53 1.53 0 0 1-1.522-1.47 1.476 1.476 0 0 1 1.448-1.53h.028a1.527 1.527 0 0 1 1.522 1.47 1.477 1.477 0 0 1-1.448 1.53Z" }) });
const ForwardRef$1 = forwardRef(SvgAlertDiamond);
const SvgAlertTriangle = (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "m23.119 20.002-9.347-17.85a2 2 0 0 0-3.543 0L.881 20.002a2 2 0 0 0 1.772 2.928h18.694a2 2 0 0 0 1.772-2.928ZM11 8.425a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0v-6Zm1.05 11.51h-.028a1.528 1.528 0 0 1-1.522-1.47 1.476 1.476 0 0 1 1.448-1.53h.028a1.527 1.527 0 0 1 1.524 1.467 1.474 1.474 0 0 1-1.45 1.533Z" }) });
const ForwardRef = forwardRef(SvgAlertTriangle);
const CheckmarkCircleFilled = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12C0 5.373 5.373 0 12 0c6.624.008 11.992 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12zm17.552-5.78a1.25 1.25 0 011.197 1.977l-6.7 9.087a1.263 1.263 0 01-1.787.235l-4.783-3.826a1.251 1.251 0 011.563-1.953l3.767 3.014 5.924-8.04c.196-.267.49-.445.819-.495z"
    }
  ) })
);
const SvgCross = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M2.44 19.44a1.5 1.5 0 002.121 2.121l7.262-7.26a.25.25 0 01.354 0l7.262 7.262a1.5 1.5 0 102.122-2.12l-7.26-7.266a.25.25 0 010-.354l7.262-7.262a1.5 1.5 0 00-2.124-2.12L12.177 9.7a.25.25 0 01-.354 0L4.561 2.44A1.5 1.5 0 002.44 4.56L9.7 11.823a.25.25 0 010 .354L2.44 19.44z" }) }));
const SvgInfocircle = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M12 0c6.624.007 11.993 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.52-.006 9.994-4.48 10-10 0-5.523-4.477-10-10-10zm-.5 7.5a2 2 0 012 2v4.75c0 .138.112.25.25.25h.75a1 1 0 010 2h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1zm.75-4.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z" }) }));
const cssVars$1 = createCssVars(["height", "padding", "borderRadius", "borderWidth", "fontSize", "fontWeight", "iconSize", "clearButtonSize"]);
const _exp = () => IconButton;
const ClearButton = /* @__PURE__ */ styled(_exp())({
  name: "ClearButton",
  class: "cb_Input_ClearButton_c1vu",
  propsAsIs: true
});
const _exp3 = () => ({
  $stretch
}) => $stretch ? "100%" : "auto";
const Root$2 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Input_Root_r145",
  propsAsIs: false,
  vars: {
    "r145yy7r-0": [_exp3()]
  }
});
const BG = /* @__PURE__ */ styled("div")({
  name: "BG",
  class: "cb_Input_BG_b1e5",
  propsAsIs: false
});
const Border = /* @__PURE__ */ styled("div")({
  name: "Border",
  class: "cb_Input_Border_b1es",
  propsAsIs: false
});
const IconContainer$2 = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_Input_IconContainer_i100",
  propsAsIs: false
});
const SuffixText = /* @__PURE__ */ styled("div")({
  name: "SuffixText",
  class: "cb_Input_SuffixText_s7ev",
  propsAsIs: false
});
const ClearButtonContainer = /* @__PURE__ */ styled("div")({
  name: "ClearButtonContainer",
  class: "cb_Input_ClearButtonContainer_c720",
  propsAsIs: false
});
const _exp18 = () => ({
  $leftPadding
}) => $leftPadding === "withIconSpace" ? `calc(2 * ${cssVars$1.padding} + ${cssVars$1.iconSize})` : cssVars$1.padding;
const ActualInput = /* @__PURE__ */ styled("input")({
  name: "ActualInput",
  class: "cb_Input_ActualInput_ayhd",
  propsAsIs: false,
  vars: {
    "ayhd9d8-0": [_exp18()]
  }
});
function useMergedRef(...refs) {
  return useCallback(
    (element) => {
      for (const ref of refs) {
        if (typeof ref === "function") {
          ref(element);
        } else if (ref && typeof ref === "object") {
          ref.current = element;
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
}
const disableValueChangeOnWheel = (event, callback) => {
  const target = event.currentTarget;
  target.blur();
  setTimeout(() => {
    target.focus({
      preventScroll: true
    });
  }, 0);
  callback == null ? void 0 : callback(event);
};
const Input = React.forwardRef(({
  autoComplete = "off",
  className,
  clearButtonAriaLabel = "Clear",
  disabled = false,
  enableValueChangeOnScrollWheel,
  fontStyle = "normal",
  icon,
  iconTitle,
  invalid = false,
  onChange,
  onClearClick,
  rootRef,
  spellCheck = false,
  stretch = true,
  style,
  styleParams,
  suffixText,
  type,
  value,
  ...rest
}, ref) => {
  const innerRef = useRef(null);
  const mergedRef = useMergedRef(ref, innerRef);
  const onMouseDown = (event) => {
    var _a;
    event.preventDefault();
    (_a = innerRef.current) == null ? void 0 : _a.focus();
  };
  return (
    /* @__PURE__ */ jsxs(Root$2, {
      $stretch: stretch,
      className,
      ref: rootRef,
      style: {
        ...(styleParams ? assignInlineCssVars(cssVars$1, styleParams) : null),
        ...style
      },
      children: [/* @__PURE__ */ jsx(ActualInput, {
        ...rest,
        $leftPadding: icon ? "withIconSpace" : "default",
        "aria-invalid": invalid,
        autoComplete,
        className: typographyClassName.Body3,
        "data-numeric": fontStyle === "numeric" && ["tel", "text"].includes(type ?? "text") ? "" : void 0,
        disabled,
        onChange,
        onWheel: type === "number" && !enableValueChangeOnScrollWheel ? (e) => disableValueChangeOnWheel(e, rest.onWheel) : rest.onWheel,
        ref: mergedRef,
        spellCheck,
        type,
        value
      }), /* @__PURE__ */ jsx(BG, {}), /* @__PURE__ */ jsx(Border, {}), !!icon && /* @__PURE__ */ jsx(IconContainer$2, {
        "aria-hidden": true,
        onMouseDown,
        title: iconTitle,
        children: icon
      }), !!suffixText && /* @__PURE__ */ jsx(SuffixText, {
        className: typographyClassName.Body3,
        onMouseDown,
        role: "presentation",
        children: suffixText
      }), !!onClearClick && /* @__PURE__ */ jsx(ClearButtonContainer, {
        "data-animate-width": !!suffixText,
        children: /* @__PURE__ */ jsx(ClearButton, {
          alignment: "iconEdges",
          "aria-label": clearButtonAriaLabel,
          background: "transparent",
          disabled,
          onClick: onClearClick,
          onMouseDown,
          size: "tiny",
          styleParams: (styleParams == null ? void 0 : styleParams.clearButtonSize) ? {
            size: styleParams == null ? void 0 : styleParams.clearButtonSize
          } : void 0,
          tabIndex: value === void 0 || value === null || value === "" ? -1 : 0,
          variant: "subdued",
          children: /* @__PURE__ */ jsx(SvgCross, {})
        })
      })]
    })
  );
});
Input.displayName = "Input";
const Input$1 = Input;
const cssVars = createCssVars(["fontSize", "lineHeight"]);
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_InputAlert_Root_r16p",
  propsAsIs: false
});
const Col = /* @__PURE__ */ styled("div")({
  name: "Col",
  class: "cb_InputAlert_Col_cire",
  propsAsIs: false
});
const _exp2 = () => Col;
const LeftCol = /* @__PURE__ */ styled(_exp2())({
  name: "LeftCol",
  class: "cb_InputAlert_LeftCol_l16y",
  propsAsIs: true
});
const _exp4 = () => Col;
const RightCol = /* @__PURE__ */ styled(_exp4())({
  name: "RightCol",
  class: "cb_InputAlert_RightCol_rqeg",
  propsAsIs: true
});
const _exp7 = () => ({
  $fill
}) => $fill;
const IconContainer$1 = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_InputAlert_IconContainer_i1s9",
  propsAsIs: false,
  vars: {
    "i1s9fe2v-0": [_exp7()]
  }
});
const Message = /* @__PURE__ */ styled("div")({
  name: "Message",
  class: "cb_InputAlert_Message_m1c2",
  propsAsIs: false
});
const icons = {
  error: {
    icon: ForwardRef$1,
    fill: color.textNegative
  },
  info: {
    icon: SvgInfocircle,
    fill: color.text
  },
  success: {
    icon: CheckmarkCircleFilled,
    fill: color.textPositive
  },
  warning: {
    icon: ForwardRef,
    fill: color.textWarning
  }
};
const InputAlert = ({
  children,
  className,
  style,
  styleParams,
  variant = "error"
}) => /* @__PURE__ */ jsxs(Root$1, {
  className,
  style: {
    ...(styleParams ? assignInlineCssVars(cssVars, styleParams) : null),
    ...style
  },
  children: [/* @__PURE__ */ jsx(LeftCol, {
    children: /* @__PURE__ */ jsx(IconContainer$1, {
      $fill: icons[variant].fill,
      children: createElement(icons[variant].icon)
    })
  }), /* @__PURE__ */ jsx(RightCol, {
    children: /* @__PURE__ */ jsx(Message, {
      className: typographyClassName.Small,
      children
    })
  })]
});
const InputAlert$1 = InputAlert;
const PADDING_TOP = 7;
const PADDING_BOTTOM = 8;
const LINE_HEIGHT = 20;
const BORDER_WIDTH = 1;
const VERTICAL_PADDING_AND_BORDER = 2 * BORDER_WIDTH + PADDING_TOP + PADDING_BOTTOM;
const IconContainer = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_Textarea_IconContainer_ie72",
  propsAsIs: false
});
const textareaBaseClass = clsx(typographyClassName.Body3, "cb_Textarea_textareaBaseClass_t7n9");
const _exp27 = () => ({
  $stretch
}) => $stretch ? "100%" : "auto";
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Textarea_Root_r163",
  propsAsIs: false,
  vars: {
    "r163ky6m-0": [_exp27()]
  }
});
const _exp28 = () => ({
  $maxHeight
}) => $maxHeight === Infinity ? "none" : `${$maxHeight}px`;
const Sizer = /* @__PURE__ */ styled("div")({
  name: "Sizer",
  class: "cb_Textarea_Sizer_s1wq",
  propsAsIs: false,
  vars: {
    "s1wq8s-0": [_exp28()]
  }
});
const _exp29 = () => ({
  $disableHorizontalResize,
  $disableVerticalResize
}) => {
  if ($disableHorizontalResize && $disableVerticalResize) {
    return "none";
  }
  if ($disableHorizontalResize && !$disableVerticalResize) {
    return "vertical";
  }
  if (!$disableHorizontalResize && $disableVerticalResize) {
    return "horizontal";
  }
  if (!$disableHorizontalResize && !$disableVerticalResize) {
    return "both";
  }
  return "auto";
};
const ActualTextarea = /* @__PURE__ */ styled("textarea")({
  name: "ActualTextarea",
  class: "cb_Textarea_ActualTextarea_a92k",
  propsAsIs: false,
  vars: {
    "a92ksen-0": [_exp29()]
  }
});
const Textarea = React.forwardRef(({
  autoComplete = "off",
  autoresizeMaxRows,
  className,
  defaultValue,
  disableHorizontalResize = false,
  disableVerticalResize = false,
  icon,
  iconTitle,
  invalid,
  rootRef,
  rows,
  spellCheck = false,
  stretch = true,
  style,
  value,
  ...rest
}, ref) => {
  const shouldStretch = autoresizeMaxRows !== void 0 || stretch;
  return /* @__PURE__ */ jsxs(Root, {
    $stretch: shouldStretch,
    className,
    ref: rootRef,
    style,
    children: [/* @__PURE__ */ jsx(ActualTextarea, {
      ...rest,
      $disableHorizontalResize: shouldStretch || disableHorizontalResize,
      $disableVerticalResize: autoresizeMaxRows !== void 0 || disableVerticalResize,
      "aria-invalid": invalid,
      autoComplete,
      className: textareaBaseClass,
      defaultValue,
      ref,
      rows: rows ?? (autoresizeMaxRows === void 0 ? void 0 : 1),
      spellCheck,
      value
    }), !!icon && /* @__PURE__ */ jsx(IconContainer, {
      title: iconTitle,
      children: icon
    }), autoresizeMaxRows !== void 0 && /* @__PURE__ */ jsxs(Sizer, {
      $maxHeight: VERTICAL_PADDING_AND_BORDER + LINE_HEIGHT * autoresizeMaxRows,
      className: textareaBaseClass,
      role: "presentation",
      children: [
        value,
        /* Trailing space is required, because without it an empty line at the end does not expand the sizer */
        " "
      ]
    })]
  });
});
Textarea.displayName = "Textarea";
const Textarea$1 = Textarea;
export {
  Input$1 as Input,
  InputAlert$1 as InputAlert,
  Textarea$1 as Textarea
};
//# sourceMappingURL=index.js.map
